var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentcreating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1600 325.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-13,.cls-34,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:#d8c4df;}.cls-4{font-size:70px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-4,.cls-7{fill:#2f2143;}.cls-5{fill:#a6a5a5;}.cls-6{fill:#dcdbdb;}.cls-8{fill:#ad6359;}.cls-9{fill:#ffc829;}.cls-10{fill:#5e433f;}.cls-11{fill:#493d3c;}.cls-12{fill:#7f4843;}.cls-13{stroke:#263238;stroke-linecap:round;stroke-width:1.14px;}.cls-13,.cls-34,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40{stroke-miterlimit:10;}.cls-14{fill:#fff;}.cls-15{fill:#9ca1a4;}.cls-16{fill:#2e3133;}.cls-17{fill:#fdc437;}.cls-18{fill:#9a499c;}.cls-19{fill:#b0adad;}.cls-20{fill:#3a7abc;}.cls-21{fill:#59add1;}.cls-22{fill:#231f20;}.cls-23{mix-blend-mode:darken;}.cls-24{clip-path:url(#clip-path);}.cls-25{clip-path:url(#clip-path-2);}.cls-26{clip-path:url(#clip-path-3);}.cls-27{fill:#e5ac24;}.cls-28{fill:#cd922a;}.cls-29{opacity:0.5;}.cls-30{clip-path:url(#clip-path-4);}.cls-31{clip-path:url(#clip-path-5);}.cls-32{clip-path:url(#clip-path-6);}.cls-33{fill:#ffc436;}.cls-34{stroke:#3a4c69;stroke-width:0.44px;}.cls-35{fill:#fdfefe;}.cls-36,.cls-38{stroke:#9a499c;}.cls-36{stroke-width:2px;}.cls-37,.cls-40{stroke:#fff;}.cls-39{stroke:#2f2143;}.cls-40{stroke-width:0.72px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 -0.1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1311.59,
    y: 219.69,
    width: 49.15,
    height: 0.79
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0 -0.1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1369.26,
    y: 219.79,
    width: 45.85,
    height: 0.79
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0 -0.1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1425.31,
    y: 219.79,
    width: 42.34,
    height: 0.79
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(0 -0.1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 400.7,
    y: 36.18,
    width: 34.94,
    height: 34.93
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(0 -0.1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 532.02,
    y: 238.7,
    width: 53.85,
    height: 53.85
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(0 -0.1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.44,
    y: 44.02,
    width: 53.86,
    height: 53.86
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "content creating") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 1600,
    height: 325.8
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(448.33 193.29)"
  }, "CONTENT MARKETING"), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "168.69 295.82 166.47 295.56 175.49 199.51 181.48 200.19 168.69 295.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "273.85 294.75 271.67 295.21 250.06 201.18 255.97 199.94 273.85 294.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "219.51 291.55 217.28 291.55 215.38 195.09 221.41 195.09 219.51 291.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "167.96 97.94 218.06 97.94 233.44 187.43 279.2 187.43 279.2 200.31 163.62 200.31 167.96 97.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M251.53,133.16l-50.61,1.5S181.64,181.48,223.54,190c0,0,27.42,7.61,36.42,7.71,0,0,26.12,3,30.75,5.93,0,0,4-7.66,9.39,89.35h28.32s2-79.18-3.38-94.35c0,0,1.11-16.74-19.77-25.71,0,0-34.37-18.35-58.43-23.83Z",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M259.29,59.69a24.88,24.88,0,0,0-.93,3.12c-.12.89-.77,9.9-6.4,7.84S243.33,59.86,243.61,59l4.68-11.57.07-1.85s-4.24-3.68-.88-10.17c0,0,2.15-2.79,4.22,2.76L257,30.42l14.66-1.17,4.73,7.21-.83,3.25s-1.28,6.91-2.54,9c0,0-3.81,12.71-13.74,10.95",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M256.86,32.13s-.92,5.5-5.57,6.21c0,0-5.74.11-4.15-6.11,0,0,.78-3.14,2.38-3.5,0,0-1.26-10.12,9.39-8.32,0,0,6.44-5.47,12.36,2.56,0,0,8.76.17,5.91,11.23,0,0,2.18,4.29-2,5.71l.16-3.47s-5.66-2.32-4.65-7.71c0,0-2.78,9.33-13.82,3.4",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M254.06,133.16l-45.42,1.35s-12.86,26.14,9.39,38.61c0,0,14.53,7.31,37.51,8.88,0,0,12,1.4,13.84,2.27,0,0,1.39,0,.08,3.85s-23.69,88-23.69,88l25.16,5.45s40.71-72.24,43.87-94.09c0,0,10.62-26-12-31.75,0,0-22.73-9.19-47.5-11.61,0,0-2.28-3.64-1.23-10.93",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M264.88,137l-68.39-1s13.69-40.82,18.64-46.19c0,0,16-28.91,27.12-30.68,0,0,2.19-2,2.16-1.67S253.19,71,253.19,71l5.35-8.17A219.59,219.59,0,0,1,270,98.21l40,6.66s-5.34,26-6.31,26.52-38.42-8-38.42-8Z",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M253.64,39.82c.5,2.86-.82,5.48-2.95,5.85s-4.26-1.64-4.76-4.5.81-5.48,2.94-5.85,4.27,1.64,4.77,4.5",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M248.22,42c.94-.74,2.08.35,2.4,1.25l-.48.19c-.74-1.77-1-4.09.24-5.69a8,8,0,0,0,.24,5.49l-.48.2c-.28-.84-.89-1.8-1.92-1.44",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M249.17,129.51a7.16,7.16,0,0,0,5.92-.41,29.63,29.63,0,0,1,3.8,3.28,2.26,2.26,0,0,0,2.54.11,2.08,2.08,0,0,0,.75-1.2,2.27,2.27,0,0,0-.09-1.29c1.34,1,2.84,1.23,3.75.62a2.2,2.2,0,0,0,.78-1,2.76,2.76,0,0,0-.14-1.82,5.54,5.54,0,0,0-.67-1.47c1.5,1.06,3.11,1.39,4.08.78a2,2,0,0,0,.82-1,2.63,2.63,0,0,0-.13-1.66,6.12,6.12,0,0,0-.66-1.5,23.17,23.17,0,0,0-1.4-1.93,22.2,22.2,0,0,0-3.66-3.69s5.92,4,6.83,4.49a2,2,0,0,0,2.32,0c.59-.61.21-1.7,0-2.21a3.87,3.87,0,0,0-1-1.59c-3.15-6.41-10.4-9.37-16.36-7.34-6.94,2.37-10.92,11.08-7.47,18.78",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M262.09,130s-.62-2.58-4.53-4.54",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M265.81,126.38s-2.16-3.6-5.29-4.61",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M243.66,90.05c-1.57,6.3-3.38,12.53-5.28,18.74l-.54-.73c8.37,0,16.72.07,25.07.56-8.6.5-17.21.61-25.83.55,2-6.42,4.19-12.82,6.58-19.12",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M249.3,132.83c-10.11,0-32.58-1.73-38.58-10.6,6.24,7.37,28.82,9.17,38.58,10.6",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M249.3,111c-5.22,3.66-5.81,10.55-5,16.37.14.86.29,1.73.38,2.62-2.89-6.23-2.68-16,4.59-19",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M242.73,274.53s-2.54,16.4-1.21,21.51c0,0,41.62,11.37,50.61,11.66,0,0,2.11-1.14-.33-8.7l-18.62-17.9Z",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M298.76,292l31.81.27,20.13,13.26s4,5.18,1.67,9.29c0,0-48.41,1.29-52.95-1.18,0,0-2-7.13-.66-21.64",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M299,311.68c17-.78,34.15-.79,51.11,0-17,.78-34.15.77-51.11,0",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M243.89,293c15.4,3.06,30.83,6.91,45.85,11.48-15.4-3.05-30.82-6.92-45.85-11.48",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M269.61,285.76c1.09-2.37,5.2-4.3,6.84-1.51-2.51-1.14-4.51.51-6.84,1.51",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M272.47,288.54c1.09-2.37,5.2-4.3,6.84-1.51-2.51-1.13-4.52.52-6.84,1.51",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M275.47,291.11c1.09-2.37,5.2-4.3,6.84-1.51-2.51-1.14-4.51.51-6.84,1.51",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M330.61,298c1.09-2.36,5.2-4.3,6.84-1.51-2.51-1.13-4.51.52-6.84,1.51",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M334,300.35c1.09-2.36,5.2-4.3,6.85-1.51-2.52-1.13-4.52.52-6.85,1.51",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M337.45,302.59c1.09-2.37,5.2-4.31,6.85-1.52-2.52-1.13-4.52.52-6.85,1.52",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 245.49,
    y: 136.2,
    width: 37.99,
    height: 3.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "302.88 96.62 299.2 96.8 280.33 138.38 283.31 139.74 302.88 96.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "302.88 96.62 344.31 96.62 327.02 140.81 283.31 139.74 302.88 96.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M337,111.5l2.17-3.56s2-4.14,4.58-3.66c0,0,1.41.66-.4,3.43a11.93,11.93,0,0,0-1.9,3.1c-.24,1.06.64,2.67.85,3.64,0,0,.18,2.46-1.57,2.7a3.08,3.08,0,0,1,1.07,2.45s0,.94-1.7,1.43a2.65,2.65,0,0,1,.67,2.1,1.91,1.91,0,0,1-1.85,1.45s.48,1.34.14,1.94c0,0-.12,1.31-2.86,1.21,0,0-4.36-.41-6.66-2.1,0,0-1.72-1.19-2-2,0,0-1.15-2.41,1.63-1.83a7.58,7.58,0,0,1-2.08-2c-.37-.86-1.3-3.6,2.73-2.59,0,0-2.09-1.39-2.07-2.52s.35-2.91,3.15-1.77c0,0-1.43-2.51-.67-3.16,0,0,.59-1.43,2.47-.29,0,0,3.25,2.21,4.26,2.11",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M331,112.84a22.28,22.28,0,0,0,9.79,4.31,12.27,12.27,0,0,1-9.79-4.31",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M329.9,117.13c3.31,1.61,6.59,3.25,10.24,3.9-3.74.15-7.37-1.62-10.24-3.9",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M329.25,121.75a30.38,30.38,0,0,0,9.71,2.83,13.22,13.22,0,0,1-9.71-2.83",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M260.52,38.37s4.17-1.38,5.29,1.54",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M269.51,40.9s4.17-1.39,5.29,1.54",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M259.53,52c.76,1,2,2.19,3.17,1.09-1,1.54-2.76.25-3.17-1.09",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M261.66,42a1.36,1.36,0,1,0,2.5.8,1.36,1.36,0,1,0-2.5-.8",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M270.33,44.37a1.36,1.36,0,1,0,2.5.8,1.36,1.36,0,1,0-2.5-.8",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M268,43.36a53.41,53.41,0,0,1,.27,7.26c-.73-.5-1.46-1-2.16-1.54s-1.14-.87-1.69-1.34a42.77,42.77,0,0,1,3.73,2.13l-.42.23a52.47,52.47,0,0,1,.27-6.74",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "164.31 200.31 157.44 200.43 162.93 97.85 169.79 97.94 164.31 200.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1504.36,231.93h-228.9V102.8a12,12,0,0,1,12-11.94h205a12,12,0,0,1,11.95,11.94Z",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1283.79,
    y: 99.09,
    width: 212.23,
    height: 128.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1494.21,250.53h-208.6a10.15,10.15,0,0,1-10.15-10.15v-8.45h228.9v8.45a10.15,10.15,0,0,1-10.15,10.15",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 1371.83,
    y: 250.43,
    width: 42.28,
    height: 15.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1362.35,
    y: 266.24,
    width: 59.67,
    height: 3.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1393,241.23a3.06,3.06,0,1,1-3.06-3.06,3.06,3.06,0,0,1,3.06,3.06",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1311.59,
    y: 152.08,
    width: 49.77,
    height: 45.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1368.97,
    y: 152.19,
    width: 46.43,
    height: 45.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1424.78,
    y: 152.19,
    width: 42.87,
    height: 45.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 1283.79,
    y: 99.09,
    width: 212.23,
    height: 12.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1469,107.68H1325.45a2,2,0,1,1,0-4.08H1469a2,2,0,0,1,0,4.08",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1472.97,
    y: 103.5,
    width: 9.48,
    height: 4.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1484.2,
    y: 103.5,
    width: 9.48,
    height: 4.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1292.53,105.64a2,2,0,1,1-2-2,2,2,0,0,1,2,2",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1300.16,105.64a2,2,0,1,1-2-2,2,2,0,0,1,2,2",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1307.79,105.64a2,2,0,1,1-2-2,2,2,0,0,1,2,2",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1315.42,105.64a2,2,0,1,1-2-2,2,2,0,0,1,2,2",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1297.15,
    y: 111.99,
    width: 175.83,
    height: 13.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 1472.97,
    y: 111.99,
    width: 23.05,
    height: 115.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 1283.79,
    y: 111.99,
    width: 23.05,
    height: 115.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 1306.85,
    y: 125.03,
    width: 166.13,
    height: 18.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1311.59,
    y: 129.57,
    width: 40.14,
    height: 11.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1361.36,
    y: 136.85,
    width: 15.86,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1384.03,
    y: 136.85,
    width: 15.86,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1406.7,
    y: 136.85,
    width: 15.86,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1429.37,
    y: 136.85,
    width: 15.86,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1452.05,
    y: 136.85,
    width: 15.86,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1311.59,
    y: 201.96,
    width: 49.15,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1311.59,
    y: 204.48,
    width: 49.15,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1311.59,
    y: 206.99,
    width: 49.15,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1311.59,
    y: 209.51,
    width: 49.15,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1311.59,
    y: 212.03,
    width: 49.15,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1311.59,
    y: 214.55,
    width: 49.15,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1311.59,
    y: 217.07,
    width: 49.15,
    height: 0.79
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1311.59,
    y: 219.59,
    width: 49.15,
    height: 0.79
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1369.26,
    y: 202.06,
    width: 45.85,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1369.26,
    y: 204.58,
    width: 45.85,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1369.26,
    y: 207.1,
    width: 45.85,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1369.26,
    y: 209.62,
    width: 45.85,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1369.26,
    y: 212.14,
    width: 45.85,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1369.26,
    y: 214.66,
    width: 45.85,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1369.26,
    y: 217.18,
    width: 45.85,
    height: 0.79
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1369.26,
    y: 219.7,
    width: 45.85,
    height: 0.79
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1425.31,
    y: 202.06,
    width: 42.34,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1425.31,
    y: 204.58,
    width: 42.34,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1425.31,
    y: 207.1,
    width: 42.34,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1425.31,
    y: 209.62,
    width: 42.34,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1425.31,
    y: 212.14,
    width: 42.34,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1425.31,
    y: 214.66,
    width: 42.34,
    height: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1425.31,
    y: 217.18,
    width: 42.34,
    height: 0.79
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1425.31,
    y: 219.7,
    width: 42.34,
    height: 0.79
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1462.92 225.15 1431.1 207.37 1431.62 243.82 1441.71 234.17 1459.23 263.53 1466.87 258.97 1449.31 229.55 1462.92 225.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "1442.14 24.66 1491.59 44.26 1467.3 59.43 1442.14 24.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "1442.14 24.66 1479.27 52.08 1479.27 61.87 1484.08 50.21 1442.14 24.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "1473.74 54.23 1479.27 61.87 1479.27 52.08 1473.74 54.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M781.28,269.2h0a21.79,21.79,0,0,0-.23-6.8h0l3.07-4.23L782,253.48l-5.2-.48,0,0a22.19,22.19,0,0,0-5-4.64h0l-.81-5.16-4.84-1.82-4,3.33v0a21.79,21.79,0,0,0-6.8.24v0l-4.23-3.06-4.71,2.13-.48,5.2,0,0a22,22,0,0,0-4.64,5v0l-5.16.82-1.82,4.84,3.33,4h0a21.73,21.73,0,0,0,.24,6.79h0l-3.07,4.23,2.14,4.71,5.19.48,0,0a21.77,21.77,0,0,0,5,4.64h0l.82,5.16,4.84,1.82,4-3.33v-.05a21.44,21.44,0,0,0,6.79-.23v0l4.23,3.07,4.7-2.13.49-5.2,0,0a22,22,0,0,0,4.65-5v0l5.16-.82,1.82-4.84ZM776,272.8a17.64,17.64,0,1,1-10.25-22.75A17.64,17.64,0,0,1,776,272.8",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M433.32,55.49h0a14.9,14.9,0,0,0-.16-4.72h0l2.13-2.94-1.48-3.27-3.61-.33,0,0A15.13,15.13,0,0,0,426.72,41h0l-.57-3.58-3.36-1.27L420,38.5v0a14.9,14.9,0,0,0-4.72.16v0l-2.93-2.13L409.1,38l-.34,3.61,0,0a15.13,15.13,0,0,0-3.22,3.45h0l-3.58.57L400.7,49l2.32,2.8h0a14.91,14.91,0,0,0,.16,4.72h0l-2.13,2.93,1.48,3.27,3.61.34,0,0a15,15,0,0,0,3.45,3.23h0l.57,3.58,3.36,1.27,2.79-2.32v0a14.9,14.9,0,0,0,4.72-.16v0L424,70.76l3.27-1.48.33-3.61,0,0a15.13,15.13,0,0,0,3.22-3.45h0l3.58-.57,1.27-3.36ZM429.63,58a12.25,12.25,0,1,1-7.12-15.8A12.25,12.25,0,0,1,429.63,58",
    transform: "translate(0 -0.1)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M555.69,272.85a10.62,10.62,0,1,0-.64-.33l.33.15c.11.05.2.12.31.18",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M555.69,272.85c-.11-.06-.2-.13-.31-.18l-.33-.15A20.05,20.05,0,0,0,533.72,275a26.81,26.81,0,0,0,32.64,16.5,20,20,0,0,0-10.67-18.64",
    transform: "translate(0 -0.1)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M78.48,78.58a10.52,10.52,0,1,0-.7.16l.34-.1c.12,0,.24,0,.36-.06",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M78.48,78.58c-.12,0-.24,0-.36.06l-.34.1a20,20,0,0,0-14.86,15.5,26.82,26.82,0,0,0,35.67-8.11,20,20,0,0,0-20.11-7.55",
    transform: "translate(0 -0.1)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 645.5,
    y: 26.69,
    width: 42.06,
    height: 60.64,
    transform: "translate(43.27 299.94) rotate(-26.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 646.53,
    y1: 50.84,
    x2: 666.01,
    y2: 41.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 648.98,
    y1: 55.84,
    x2: 668.46,
    y2: 46.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 651.44,
    y1: 60.83,
    x2: 670.91,
    y2: 51.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 653.89,
    y1: 65.82,
    x2: 673.37,
    y2: 56.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 656.35,
    y1: 70.81,
    x2: 675.82,
    y2: 61.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 658.8,
    y1: 75.8,
    x2: 678.28,
    y2: 66.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 661.26,
    y1: 80.79,
    x2: 680.73,
    y2: 71.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 663.71,
    y1: 85.78,
    x2: 683.19,
    y2: 76.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 663.96,
    y: 26.25,
    width: 9.62,
    height: 10.2,
    transform: "translate(54.82 298.28) rotate(-26.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1138.87,60.92a19,19,0,1,1-19-19A19,19,0,0,1,1138.87,60.92Z",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M418.17,202.93a9.55,9.55,0,1,1-9.55-9.54A9.54,9.54,0,0,1,418.17,202.93Z",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1558.4,186a11.48,11.48,0,1,1-11.48-11.47A11.48,11.48,0,0,1,1558.4,186Z",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-39",
    points: "47.7 258.21 64.71 270.1 72.24 250.76 89.25 262.65 96.79 243.32 113.8 255.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-39",
    points: "1163.32 283.82 1184.02 285.26 1180.53 264.81 1201.23 266.25 1197.75 245.79 1218.45 247.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M991.34,248.94,963.9,268.83a3.28,3.28,0,0,0-.73,4.59l9.33,12.87a3.28,3.28,0,0,0,4.59.73l2.25-1.63c.79.75,2.58,3,.68,6.85,0,0,7.79-6.24,4.69-10.75l19.81-14.36a3.28,3.28,0,0,0,.73-4.59l-9.33-12.87a3.28,3.28,0,0,0-4.58-.73",
    transform: "translate(0 -0.1)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-40",
    x1: 969.66,
    y1: 271.86,
    x2: 992.5,
    y2: 255.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-40",
    x1: 972.69,
    y1: 276.04,
    x2: 995.53,
    y2: 259.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-40",
    x1: 976.02,
    y1: 280.62,
    x2: 998.85,
    y2: 264.07
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentcreating);
export default __webpack_public_path__ + "static/media/content creating.da4d607e35f5eae507256dbb4f75f2f0.svg";
export { ForwardRef as ReactComponent };